<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <b-row class="d-flex justify-content-between">
        <b-col cols="6">
          <b-row>
            <b-col>
              <span class="search">
                <label>
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                  <input
                    type="search"
                    class="search-input"
                    placeholder="Search Publishings"
                    v-model="searchStr"
                  /> </label
              ></span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6" style="float: right">
          <b-row>
            <b-col>
              <b-link @click="handlePublishingDocLevelClick('doc')">
                All
              </b-link>
              ({{ totalCount }}) |
              <b-link @click="handlePublishingDocLevelClick('doc_stage')">
                submitted
              </b-link>
              ({{ publishings ? totalDocCount("doc_stage") : 0 }}) |
              <b-link @click="handlePublishingDocLevelClick('doc')">
                live
              </b-link>
              ({{ publishings ? totalDocCount("doc") : 0 }}) |
              <b-link
                :disabled="true"
                @click="handlePublishingDocLevelClick('doc_rollback')"
              >
                versioned
              </b-link>
              ({{ publishings ? totalDocCount("versions") : 0 }})|
              <b-link
                :disabled="true"
                @click="handlePublishingDocLevelClick('doc_local')"
              >
                local
              </b-link>
            </b-col>
            <b-col>
              <spreadsheet
                ref="spreadsheet"
                :columns="columns"
                :content="content"
                :busy="isBusy"
                file-name="Publishings"
                sheet-name="Publishings"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="publishings" role="tablist">
        <b-card no-body>
          <b-table
            id="table-transition-example"
            :items="filteredPublishings"
            :fields="filteredFields"
            :busy="isBusy"
            striped
            hover
            small
            primary-key="a"
            :tbody-transition-props="transProps"
            show-empty
          >
            <template #table-busy>
              <b-skeleton-table
                :rows="skeletonRows"
                :columns="filteredFields.length"
                :table-props="{ bordered: true, striped: true }"
              />
            </template>
            <template #empty="scope">
              No Data Available
            </template>
            <template #cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template #cell(title)="row">
              {{ row.item[docLevel].title }}
            </template>
            <template #cell(coverurl)="row">
              <b-img
                v-if="row.item[docLevel] && row.item[docLevel].imgURL"
                v-bind="
                  row.item[docLevel] && row.item[docLevel].imgURL
                    ? mainProps
                    : mainPropsBlank
                "
                :src="row.item[docLevel].imgURL"
                rounded
                alt="Rounded image"
              />
            </template>
            <template #cell(owner)="row">
              <div class="text-center">
                <b-img
                  v-bind="
                    row.item.owner && row.item.owner.imgURL
                      ? mainProps
                      : mainPropsBlank
                  "
                  rounded="circle"
                  :src="
                    row.item.owner && row.item.owner.imgURL
                      ? row.item.owner.imgURL
                      : ''
                  "
                  :alt="
                    row.item.owner && row.item.owner.firstname
                      ? `${row.item.owner.firstname} photo`
                      : ''
                  "
                />
                <div v-if="row.item.owner && row.item.owner.firstname">
                  {{ row.item.owner.firstname + " " + row.item.owner.lastname }}
                </div>
              </div>
            </template>
            <template #cell(actions)="row">
              <div class="actions">
                <b-link
                  size="sm"
                  @click="handleViewFeature(cornerId, row.item)"
                  class="mt-2"
                  :disabled="loadingwpArticles"
                >
                  <img :src="viewCornerSVG" />
                </b-link>
                <b-link
                  size="sm"
                  @click="handleViewFeature(qrId, row.item)"
                  class="mt-2"
                  :disabled="loadingwpArticles"
                >
                  <img :src="viewQRSVG" />
                </b-link>
                <b-link
                  size="sm"
                  @click="
                    handleViewFeature(insightsId, row.item[this.docLevel])
                  "
                  class="mt-2"
                  :disabled="loadingwpArticles"
                >
                  <img :src="viewInsightsSVG" />
                </b-link>
              </div>
            </template>
            <template #cell(descriptiontap)="data">
              <tip-tap-output
                v-if="data.item[docLevel].description"
                :content="data.item[docLevel].description"
                :show-less-char="200"
                :use-dots="true"
              />
            </template>
            <template #cell(feedback)="row">
              <b-button
                :id="`popover-target-${row.item.id}`"
                size="sm"
                class="mt-2"
                style="background: transparent; border-style: none;"
              >
                <svg
                  width="42"
                  height="41"
                  viewBox="0 0 42 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.71739 30.3259C7.81248 29.9788 7.60407 29.4962 7.40518 29.1483C7.34352 29.0444 7.27633 28.9439 7.20391 28.8472C5.49805 26.2602 4.58884 23.2295 4.58895 20.1307C4.56042 11.2359 11.9362 4.01782 21.0568 4.01782C29.011 4.01782 35.6515 9.52825 37.2022 16.843C37.4349 17.9275 37.5526 19.0334 37.5532 20.1426C37.5532 29.0501 30.462 36.3815 21.3413 36.3815C19.8904 36.3815 17.9339 36.017 16.8666 35.7182C15.7992 35.4195 14.7334 35.0233 14.4584 34.9171C14.1769 34.809 13.878 34.7534 13.5765 34.7531C13.2477 34.7519 12.922 34.8174 12.6192 34.9456L7.24353 36.8854C7.12605 36.9362 7.00154 36.9688 6.87426 36.9821C6.77359 36.9818 6.67397 36.9615 6.58118 36.9225C6.48839 36.8834 6.40426 36.8264 6.33366 36.7546C6.26307 36.6828 6.2074 36.5978 6.16989 36.5043C6.13238 36.4109 6.11377 36.311 6.11513 36.2103C6.12174 36.122 6.13768 36.0346 6.16268 35.9496L7.71739 30.3259Z"
                    stroke="var(--theme-color)"
                    stroke-width="1.90179"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                  <path
                    d="M13.4644 23.0357C14.8649 23.0357 16.0001 21.9004 16.0001 20.4999C16.0001 19.0995 14.8649 17.9642 13.4644 17.9642C12.064 17.9642 10.9287 19.0995 10.9287 20.4999C10.9287 21.9004 12.064 23.0357 13.4644 23.0357Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    d="M21.0718 23.0357C22.4723 23.0357 23.6076 21.9004 23.6076 20.4999C23.6076 19.0995 22.4723 17.9642 21.0718 17.9642C19.6714 17.9642 18.5361 19.0995 18.5361 20.4999C18.5361 21.9004 19.6714 23.0357 21.0718 23.0357Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    d="M28.6783 23.0357C30.0787 23.0357 31.214 21.9004 31.214 20.4999C31.214 19.0995 30.0787 17.9642 28.6783 17.9642C27.2779 17.9642 26.1426 19.0995 26.1426 20.4999C26.1426 21.9004 27.2779 23.0357 28.6783 23.0357Z"
                    fill="var(--theme-color)"
                  />
                </svg>
              </b-button>
              <b-popover
                :target="`popover-target-${row.item.id}`"
                triggers="hover"
                placement="top"
              >
                <template #title>Publishing Feedback</template>
                <div>
                  <span class="mr-2">Thank Yous:</span>
                  <span
                    v-if="row.item.feedback && row.item.feedback.thankyous"
                    >{{ row.item.feedback.thankyous.length }}</span
                  >
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="mr-2">Comments:</span>
                  <span
                    v-if="row.item.feedback && row.item.feedback.feedback"
                    >{{ row.item.feedback.feedback.length }}</span
                  >
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="mr-2">Bookmarks:</span>
                  <span v-if="row.item.feedback && row.item.feedback.bookmarks">
                    {{ row.item.feedback.bookmarks.length }}
                  </span>
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="mr-2">Views:</span>
                  <span v-if="row.item.feedback && row.item.feedback.views">
                    {{ row.item.feedback.views.length }}
                  </span>
                  <span v-else>0</span>
                </div>
              </b-popover>
            </template>
            <template #cell(editPublishing)="row">
              <div class="actions">
                <b-link
                  size="sm"
                  @click="editPublishing(row.item)"
                  class="mt-2"
                  :disabled="loadingwpArticles"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-link
                  size="sm"
                  class="mt-2"
                  :disabled="loadingwpArticles"
                  @click="showDeleteBlog(row.item)"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                      fill="#FF8C7D"
                    />
                  </svg>
                </b-link>
              </div>
            </template>
            <template #cell(editStatus)="row">
              <div class="status">
                <span
                  class="status-btn"
                  :style="{ background: getStatusColor(row.item.status) }"
                >
                  {{ getStatus(row.item.status) }}
                </span>
                <b-link
                  style="{ display: block }"
                  size="sm"
                  @click="editStatus(row.item)"
                  class="mt-2"
                >
                  <small>Update</small>
                </b-link>
              </div>
            </template>
            <template #cell(details)="row">
              <b-icon
                v-if="row.detailsShowing"
                @click="row.toggleDetails"
                icon="chevron-compact-up"
                font-scale="2"
              >
              </b-icon>
              <b-icon
                v-else
                @click="row.toggleDetails"
                icon="chevron-compact-down"
                font-scale="2"
              >
              </b-icon>
            </template>
            <template #row-details="row">
              <b-card>
                <div class="entry">
                  <span class="heading">Publishing ID:</span>
                  <span>{{ row.item.id }} </span>
                </div>
                <div
                  class="entry"
                  v-if="row.item.track && row.item.track.summary"
                >
                  <span class="heading">Summary</span>
                  <span>{{ row.item.track.summary.substring(0, 300) }} </span>
                </div>
                <div class="entry">
                  <span class="heading">Description:</span>
                  <span v-if="row.item[docLevel] && row.item[docLevel].detail"
                    >{{ row.item[docLevel].detail.substring(0, 90) }}
                  </span>
                  <span v-else>-</span>
                </div>
                <div class="entry">
                  <span class="heading">Slug:</span>
                  <span v-if="row.item.slug">{{ row.item.slug }} </span>
                  <span v-else>-</span>
                </div>
                <div class="entry">
                  <span class="heading">SEOs:</span>
                  <span v-if="row.item[docLevel].seo.length > 0">
                    <span v-for="(tag, i) in row.item[docLevel].seo" :key="i">
                      {{ tag }}
                    </span>
                  </span>
                  <span v-else>-</span>
                </div>
                <div class="entry d-flex align-center">
                  <span class="heading">Guides:</span>
                  <div
                    class="detail-tools"
                    v-if="
                      row.item[docLevel] &&
                        row.item[docLevel].guides &&
                        row.item[docLevel].guides.length > 0
                    "
                  >
                    <img
                      v-for="(guide, i) in row.item[this.docLevel].guides"
                      :src="guide.imgURL"
                      :key="i"
                      :alt="guide.name"
                      v-b-tooltip.hover
                      :title="guide.name"
                      width="85"
                      height="75"
                      class="mr-2"
                    />
                  </div>
                  <span v-else>-</span>
                </div>
                <div class="entry d-flex align-center">
                  <span class="heading">Tools:</span>
                  <div
                    class="detail-tools"
                    v-if="
                      row.item[docLevel] &&
                        row.item[docLevel].tools &&
                        row.item[docLevel].tools.length > 0
                    "
                  >
                    <img
                      v-for="(tool, i) in row.item[docLevel].tools"
                      :src="tool.imgURL"
                      :key="i"
                      :alt="tool.name"
                      v-b-tooltip.hover
                      :title="tool.name"
                      width="85"
                      height="75"
                    />
                  </div>
                  <span v-else>-</span>
                </div>
                <div class="entry d-flex align-center">
                  <span class="heading">Connections:</span>
                  <div
                    class="detail-tools"
                    v-if="
                      row.item[docLevel] &&
                        row.item[docLevel].connections &&
                        row.item[docLevel].connections.length > 0
                    "
                  >
                    <img
                      v-for="(connection, i) in row.item[docLevel].connections"
                      :src="connection.imgURL"
                      :key="i"
                      :alt="connection.name"
                      v-b-tooltip.hover
                      :title="connection.name"
                      width="85"
                      height="75"
                    />
                  </div>
                  <span v-else>-</span>
                </div>
              </b-card>
            </template>
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="filteredPublishings.length"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
        />
      </div>
      <modal :id="publishingStatusModal">
        <div class="add-user">
          <span class="close-icon" @click="closeStatusModal">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Edit Status</h3>
          <div class="h-18"></div>

          <div class="track">
            <div class="img-track">
              <div class="cursor-pointer">
                <img
                  v-if="
                    selectedPublishing &&
                      selectedPublishing.track &&
                      selectedPublishing.track.imgURL
                  "
                  :src="selectedPublishing.track.imgURL"
                  alt="Publishing Image"
                />
              </div>
            </div>
            <div class="publishing-content">
              <div
                v-if="
                  selectedPublishing &&
                    selectedPublishing.track &&
                    selectedPublishing.track.imgURL
                "
                class="cursor-pointer"
              >
                <h2 class="title">
                  {{ selectedPublishing.track.title }}
                </h2>
                <p class="description">
                  {{ selectedPublishing.track.summary.substring(0, 65) }}...
                </p>
              </div>
              <div class="track-foot">
                <div class="author">
                  <img
                    v-if="
                      selectedPublishing &&
                        selectedPublishing.owner &&
                        selectedPublishing.owner.imgURL
                    "
                    :src="selectedPublishing.owner.imgURL"
                    :alt="selectedPublishing.owner.firstname"
                  />
                  <!-- <h5>{{ trackgerFullname }}</h5> -->
                  <h5 v-if="selectedPublishing && selectedPublishing.owner">
                    {{
                      selectedPublishing.owner.firstname +
                        " " +
                        selectedPublishing.owner.lastname
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tools"
            v-if="
              selectedPublishing &&
                selectedPublishing[this.docLevel] &&
                selectedPublishing[this.docLevel].guides &&
                selectedPublishing[this.docLevel].guides.length > 0
            "
          >
            <h6>Guides:</h6>
            <img
              v-for="(guide, i) in selectedPublishing[this.docLevel].guides"
              :src="guide.imgURL"
              :key="i"
              :alt="guide.name"
              v-b-tooltip.hover
              :title="guide.name"
              width="30"
            />
          </div>
          <div
            class="tools"
            v-if="
              selectedPublishing &&
                selectedPublishing[this.docLevel] &&
                selectedPublishing[this.docLevel].tools &&
                selectedPublishing[this.docLevel].tools.length > 0
            "
          >
            <h6>Tools:</h6>
            <img
              v-for="(tool, i) in selectedPublishing[this.docLevel].tools"
              :src="tool.imgURL"
              :key="i"
              :alt="tool.name"
              v-b-tooltip.hover
              :title="tool.name"
              width="30"
            />
          </div>
          <div
            class="tools"
            v-if="
              selectedPublishing &&
                selectedPublishing[this.docLevel] &&
                selectedPublishing[this.docLevel].connections &&
                selectedPublishing[this.docLevel].connections.length > 0
            "
          >
            <h6>Connections:</h6>
            <img
              v-for="(connection, i) in selectedPublishing[this.docLevel]
                .connections"
              :src="connection.imgURL"
              :key="i"
              :alt="connection.name"
              v-b-tooltip.hover
              :title="connection.name"
              width="30"
            />
          </div>
          <b-form-group class="mt-3">
            <b-form-select
              v-model="modalStatus"
              :options="statusOptions"
            ></b-form-select>
          </b-form-group>
          <div class="d-flex justify-content-between mt-4">
            <b-button variant="light btn-simple" @click="closeStatusModal">
              Cancel
            </b-button>
            <b-button variant="primary btn-round-fill" @click="updateStatus">
              Update
            </b-button>
          </div>
        </div>
      </modal>
      <tool-corner-editor
        :sidebar-id="cornerId"
        :publishing-id="selectedPublishingId"
        @refresh-publishings="handleRefreshData"
      />
      <tool-qr-generator
        :sidebar-id="qrId"
        :publishing-id="selectedPublishingId"
        @refresh-publishings="handleRefreshData"
      />
      <tool-insights-viewer
        :sidebar-id="insightsId"
        :publishing-id="selectedPublishingId"
        @refresh-publishings="handleRefreshData"
      />
      <tool-development
        :sidebar-id="insightsId"
        :publishing-id="selectedPublishingId"
        @refresh-publishings="handleRefreshData"
      />
      <tool-data
        :sidebar-id="insightsId"
        :publishing-id="selectedPublishingId"
        @refresh-publishings="handleRefreshData"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Modal from "@/components/common/modal";
import Spreadsheet from "@/components/common/spreadsheet";
import TipTapOutput from "@/components/common/tipTapOutput";
import ToolCornerEditor from "../../platform/publishings/sidebars/toolCornerEditor"; //TODO- Move to Components
import ToolQrGenerator from "../../platform/publishings/sidebars/toolQRGenerator";
import ToolInsightsViewer from "../../platform/publishings/sidebars/toolInsightsViewer";
import ToolDevelopment from "../../platform/publishings/sidebars/toolDevelopment";
import ToolData from "../../platform/publishings/sidebars/toolData";
export default {
  name: "Admin_Manage_Publishings",
  components: {
    Modal,
    Spreadsheet,
    TipTapOutput,
    ToolCornerEditor,
    ToolQrGenerator,
    ToolInsightsViewer,
    ToolDevelopment,
    ToolData
  },
  props: {},
  computed: {
    ...mapGetters({
      profile: "user/profile",
      publishings: "admin/publishings",
      allBloggers: "admin/activeBloggers" //TODO- Active Crew
    }),
    totalCount() {
      return this.publishings && Array.isArray(this.publishings)
        ? this.publishings.length
        : 0;
    },
    totalFilteredCount() {
      return this.filteredPublishings && Array.isArray(this.filteredPublishings)
        ? this.filteredFields.length
        : 0;
    },
    isBusy() {
      return !this.publishings || !this.fetchedPublishings;
    },
    filteredPublishings() {
      //Doc Level
      let filteredPublishings = this.publishings.filter(aPublishing => {
        return (
          aPublishing.hasOwnProperty(this.docLevel) &&
          aPublishing[this.docLevel] !== null
        );
      });

      if (this.searchStr.trim() == "") return filteredPublishings;

      //Search
      return filteredPublishings && Array.isArray(filteredPublishings)
        ? filteredPublishings.filter(aFilteredPublishing => {
            return aFilteredPublishing.slug
              ? aFilteredPublishing.slug
                  .toLowerCase()
                  .includes(this.searchStr.toLowerCase().trim())
              : false ||
                (aFilteredPublishing[this.docLevel] &&
                  aFilteredPublishing[this.docLevel].title)
              ? aFilteredPublishing[this.docLevel].title
                  .toLowerCase()
                  .includes(this.searchStr.toLowerCase().trim())
              : false;
          })
        : [];
    },
    filteredFields() {
      return this.fields && Array.isArray(this.fields)
        ? this.fields.filter(aField => {
            return aField.isAvail;
          })
        : [];
    },
    columns() {
      return this.convertFieldToColumn(this.fields);
    },
    content() {
      switch (this.convertType) {
        case "json":
          return this.convertItemsToContentJSON(this.filteredPublishings);
        default:
          //pretty
          return this.convertItemsToContent(this.filteredPublishings);
      }
    }
  },
  mounted() {},
  methods: {
    handleActivation() {
      this.handleRefreshData();
    },
    totalDocCount(docLevel) {
      return this.publishings && Array.isArray(this.publishings)
        ? this.publishings.filter(aPublishing => {
            return (
              aPublishing.hasOwnProperty(docLevel) &&
              aPublishing[docLevel] !== null
            );
          }).length
        : 0;
    },
    handlePublishingDocLevelClick(level) {
      //validate that admin has permissions
      this.docLevel = level;
    },
    formatTipTapToHTML(content) {
      //Move to spreadsheet
      return "test";
    },
    handleRefreshData() {
      this.fetchedPublishings = false;
      this.$store
        .dispatch("admin/getPublishings")
        .then(resp => {
          this.fetchedPublishings = true;
        })
        .finally(data => {
          this.fetchedPublishings = true;
        });
    },
    handleViewFeature(sidebarId, publishing) {
      this.selectedPublishing = publishing[this.docLevel];
      this.selectedPublishingId = this.selectedPublishing.id;
      console.log(
        `Feature ${sidebarId} Publishing: ${this.selectedPublishingId}`
      );
      this.$root.$emit("bv::toggle::collapse", sidebarId);
    },
    convertFieldToColumn(fields) {
      const columns = JSON.parse(JSON.stringify(fields));

      columns.forEach(aColumn => {
        if (aColumn.hasOwnProperty("key")) {
          aColumn.value = aColumn.key;
          delete aColumn["key"];
        }
        if (aColumn.hasOwnProperty("sortable")) {
          delete aColumn["sortable"];
        }
        if (aColumn.hasOwnProperty("tdClass")) {
          delete aColumn["tdClass"];
        }
        if (aColumn.hasOwnProperty("formatter")) {
          delete aColumn["formatter"];
        }
        if (aColumn.hasOwnProperty("isAvail")) {
          delete aColumn["isAvail"];
        }
      });

      return columns;
    },
    convertItemsToContentJSON() {
      //all or just docLevel
      const content = [];
      if (this.filteredPublishings && Array.isArray(this.filteredPublishings)) {
        let index = 1;
        this.filteredPublishings.forEach(anItem => {
          const publishing = anItem[this.docLevel];
          const thisContent = {
            index: index++,
            id: publishing.id,
            title: publishing.title,
            coverurl: publishing.imgURL,
            descriptiontap: JSON.stringify(publishing.description),
            owner: "",
            status: anItem.status,
            copyright: publishing.copyright,
            isbn: publishing.isbn,
            language: publishing.language,
            pages: publishing.pages,
            _created_at: this.formatDate(publishing._created_at),
            _submitted_at: this.formatDate(publishing._submitted_at),
            _updated_at: this.formatDate(publishing._updated_at)
          };

          //TOOLS
          if (publishing.tools && Array.isArray(publishing.tools)) {
            let tools = "";
            publishing.tools.forEach(aTool => {
              const newTool = `(${aTool.toolId})${aTool.name}`;
              tools = tools.length > 0 ? `${tools},${newTool}` : newTool;
            });
            thisContent.tools = tools;
          }
          content.push(thisContent);
        });
      }
      return content;
    },
    convertItemsToContent() {
      const content = [];
      if (this.filteredPublishings && Array.isArray(this.filteredPublishings)) {
        let index = 1;
        this.filteredPublishings.forEach(anItem => {
          const publishing = anItem[this.docLevel];
          const thisContent = {
            index: index++,
            id: publishing.id,
            title: publishing.title,
            coverurl: publishing.imgURL,
            descriptiontap: JSON.stringify(publishing.description),
            owner: "",
            status: anItem.status,
            copyright: publishing.copyright,
            isbn: publishing.isbn,
            language: publishing.language,
            pages: publishing.pages,
            _created_at: this.formatDate(publishing._created_at),
            _submitted_at: this.formatDate(publishing._submitted_at),
            _updated_at: this.formatDate(publishing._updated_at)
          };

          //TOOLS
          if (publishing.tools && Array.isArray(publishing.tools)) {
            let tools = "";
            publishing.tools.forEach(aTool => {
              const newTool = `(${aTool.toolId})${aTool.name}`;
              tools = tools.length > 0 ? `${tools},${newTool}` : newTool;
            });
            thisContent.tools = tools;
          }
          content.push(thisContent);
        });
      }
      return content;
    },
    formatDate(date) {
      //TODO- Move to mixin
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    getDate(date) {
      return moment(date).format("DD MMMM");
    },
    editPublishing(track) {
      this.edit = true;
      this.resetForm();
      this.selectedPublishingId = track.id;
      if (track.owner) this.currentBlogger = track.owner;
      if (track.track && track.track.title) {
        this.modalTitle = track.track.title;
      } else {
        this.modalTitle = track[this.docLevel].title;
      }
      if (track.track && track.track.mins) {
        this.modalMins = track.track.mins;
      }
      if (track.track && track.track.summary) {
        this.modalSummary = track.track.summary;
      }
      if (track.track && track.track.imgURL) {
        this.activeImg = track.track.imgURL;
      }
      if (track.track && track.track.wpId) {
        this.selectedWpId = track.track.wpId;
        this.stripedImages = this.getImages(track.track.wpId);
      }
      if (track.slug) {
        this.modalSlug = track.slug;
      }
      this.$bvModal.show(this.trackModal);
    },
    getSummary(id) {
      let summary = "";
      let track = this.wpArticles.filter(track => track.id === id);
      var el = document.createElement("div");
      el.innerHTML = track[0].content.rendered;
      var texts = [].map.call(el.querySelectorAll("p"), function(p) {
        return p.textContent;
      });
      for (let index = 0; index < texts.length; index++) {
        if (texts[index] !== "") {
          summary += texts[index];
        }
      }
      return summary;
    },
    calculateMinutes(summary) {
      let wordsCount = summary.match(/(\w+)/g).length;
      let mins = Math.ceil(wordsCount / 200);
      return mins;
    },
    getImages(id) {
      let imageUrls = [];
      let track = this.wpArticles.filter(track => track.id === id);
      let content = track[0].content.rendered;
      var elem = document.createElement("div");
      elem.innerHTML = content;
      var images = elem.getElementsByTagName("img");
      for (var i = 0; i < images.length; i++) {
        imageUrls.push(images[i].src);
      }
      return imageUrls;
    },
    getStatus(status) {
      switch (status) {
        case "draft":
          return "Draft";
        case "submitted":
          return "Submitted";
        case "need_work":
          return "Needs Work";
        case "inactive":
          return "Removed";
        case "active":
          return "Published";
        default:
          return "Draft";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "draft":
          return "#C0C0C0";
        case "submitted":
          return "#557efb";
        case "need_work":
          return "#FFCC00";
        case "inactive":
          return "#FF0000";
        case "active":
          return "#4BB543";
        default:
          return "#C0C0C0";
      }
    },
    editStatus(publishing) {
      this.selectedPublishing = publishing;
      this.modalStatus = publishing.status;
      this.$bvModal.show(this.publishingStatusModal);
    },
    updateStatus() {
      debugger;
      const updates = {
        ownerId: this.selectedPublishing.owner.userId,
        id: this.selectedPublishing.id,
        status: this.modalStatus,
        by: this.profile.userId
      };
      this.$store.dispatch("admin/updatePublishingStatus", updates).then(() => {
        this.handleRefreshData();
        this.selectedPublishing = null;
        this.modalStatus = null;
        this.$bvModal.hide(this.publishingStatusModal);
      });
    },
    closeStatusModal() {
      this.selectedPublishing = null;
      this.modalStatus = null;
      this.$bvModal.hide(this.publishingStatusModal);
    },
    resetForm() {
      this.modalTitle = "";
      this.modalMins = 0;
      this.modalSlug = "";
      this.modalSummary = "";
      this.activeImg = null;
      this.selectedPublishingId = null;
      this.selectedWpId = null;
      this.currentBlogger = null;
    },
    showDeleteBlog(track) {
      this.edit = false;
      this.del = true;
      this.selectedPublishingId = track.id;
      this.$bvModal.show(this.trackModal);
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      mainPropsBlank: {
        blank: true,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      docLevel: "doc_stage", //doc, doc_stage //versions, doc_local
      convertType: "json", //pretty,
      cornerId: `corner`,
      qrId: `qr`,
      insightsId: `insights`,
      viewCornerSVG: require("@/assets/svg/view-corner.svg"),
      viewQRSVG: require("@/assets/svg/view-qr.svg"),
      viewInsightsSVG: require("@/assets/svg/view-insights.svg"),
      skeletonRows: 10,
      fetchedPublishings: false,
      searchStr: "",
      popupText: "Copy to clipboard",
      wpArticles: [],
      trackModal: "edit-track-modal",
      publishingStatusModal: "edit-publishing-status",
      modalTitle: "",
      modalSlug: "",
      edit: false,
      del: false,
      modalMins: 0,
      modalSummary: "",
      activeImg: null,
      stripedImages: [],
      selectedPublishingId: null,
      selectedWpId: null,
      loadingwpArticles: false,
      selectedPublishing: null,
      modalStatus: null,
      currentBlogger: null,
      activeCollapse: -1,
      statusOptions: [
        { value: null, text: "Please select an option" },
        { value: "submitted", text: "Submitted" },
        { value: "need_work", text: "Needs Work" },
        { value: "publish", text: "Publish" },
        { value: "republish", text: "Update Publish" },
        { value: "inactive", text: "Inactive/Remove" }
      ],
      transProps: {
        name: "flip-list"
      },
      fields: [
        {
          key: "index",
          label: "Index",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "id",
          label: "ID",
          sortable: true,
          isAvail: false,
          inDB: ["id", "doc_.id"]
        },
        {
          key: "isbn",
          label: "ISBN",
          sortable: true,
          isAvail: true,
          inDB: ["id", "doc_.id"]
        },
        {
          key: "coverurl",
          label: "Cover",
          isAvail: true,
          inDB: "doc_.isbn"
        },
        {
          key: "title",
          label: "Title",
          sortable: true,
          tdClass: "colWidth",
          isAvail: true,
          inDB: "doc_.title"
        },
        {
          key: "subtitle",
          label: "Subtitle",
          isAvail: false,
          inDB: "doc_.title"
        },
        {
          key: "descriptiontap",
          label: "Description",
          isAvail: true,
          inDB: "doc_.description"
        },
        {
          key: "pages",
          label: "Pages",
          isAvail: false,
          inDB: "doc_.pages"
        },
        {
          key: "price",
          label: "Price",
          isAvail: false,
          inDB: "doc_.price"
        },
        {
          key: "publisher",
          abel: "Publisher",
          isAvail: false,
          inDB: "doc_.publisher"
        },
        {
          key: "copyright",
          label: "Copyright",
          isAvail: false,
          inDB: "doc_.copyright"
        },
        {
          key: "language",
          label: "Language",
          isAvail: false,
          inDB: "doc_.langugages"
        },
        {
          key: "owner",
          label: "Owner",
          isAvail: true,
          inDB: null
        },
        {
          key: "editStatus",
          label: "Status",
          sortable: true,
          sortByFormatted: true,
          isAvail: true
        },
        {
          key: "actions",
          label: "Actions",
          isAvail: true
        },
        {
          key: "feedback",
          label: "Feedback",
          isAvail: true,
          inDB: null
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          isAvail: false,
          inDB: "doc_.status"
        },
        {
          key: "tools",
          label: "TOOLS",
          isAvail: false,
          inDB: null
        },
        {
          key: "_created_at",
          label: "Created",
          isAvail: false,
          inDB: "doc_._created_at"
        },
        {
          key: "_submitted_at",
          label: "Submitted",
          isAvail: false,
          inDB: "doc_._submitted_At"
        },
        {
          key: "_updated_at",
          label: "Updated",
          isAvail: false,
          inDB: "doc_._updated_at"
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }]
    };
  }
};
</script>

<style lang="scss" scoped>
.add-users {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-user {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.publishings {
  margin-top: 20px;
  .ico {
    cursor: pointer;
  }
  .cover-img {
    width: 150px;
  }
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.post {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  span {
    font-weight: bold;
  }
}
.active {
  background: rgb(164, 214, 255);
}
.track-images {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.track-image {
  cursor: pointer;
  width: 130px;
  height: 100px;
  border-radius: 10px;
  margin: 10px 15px;
}
.active-image {
  border: 5px solid var(--theme-color);
}
.entry {
  padding: 7px;
  .heading {
    width: 120px;
    margin-right: 15px;
    font-weight: bold;
  }
}
.track {
  display: grid;
  grid-template-columns: 198px 1fr;
  grid-column-gap: 23px;
  margin-bottom: 24px;
  align-items: stretch;
  .img-track {
    width: 198px;
    height: 100%;
    & > div {
      height: 100%;
    }
    img {
      height: 152px;
      width: 100%;
      object-fit: cover;
    }
  }
}
.publishing-content {
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #52595e;
    margin-bottom: 8px;
  }
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #8d99a0;
    margin-bottom: 8px;
  }
  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .read-more-btn {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: var(--theme-color);
    }
    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 8px;
      .read {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
  }
  .track-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .author {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 12px;
      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      grid-column-gap: 16px;
    }
  }
}
.tools {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
}
.detail-tools {
  width: 370px;
  border: 1px solid #eceff9;
}
.status {
  margin-top: 0.5rem;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}

.actions {
  display: flex;
  justify-content: space-evenly;
}
.owner-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.publishings .colWidth {
  max-width: 100px;
}
</style>
